import { IApiError } from '@/models/apiError.model';
import {
  BlogPostListSortDirection,
  BlogPostListSortField,
  IBlogCategoryListItem,
  IBlogPostListItem,
} from '@/models/blog-post.model';
import { IContentBlockSchemaItem } from '@/models/content-block-schema.model';
import { IContentPage } from '@/models/content-page.model';
import { SupportedLocales } from '@/models/localization.model';
import { SerializedError } from '@reduxjs/toolkit';

export const CONTENT_PAGES_SLICE_NAME = 'contentPages';

export interface ContentPagesMetaFieldErrors {
  invalidNameLocales?: SupportedLocales[];
  invalidSlugLocales?: SupportedLocales[];
}

export interface ContentPagesListState {
  items: IBlogPostListItem[];
  isLoading: boolean;
  currentPage: number;
  total: number;
  pageSize: number;
  blogCategoryId: string | null;
  /** Title / name filter */
  search: string;
  searchId: string;
  searchAuthor: string;
  sortField: BlogPostListSortField;
  sortDirection: BlogPostListSortDirection;
}

export interface ContentPagesEditorState {
  page: IContentPage | null;
  isPageLoading: boolean;
  isSaving: boolean;
  isReverting: boolean;
  selectedBlockId: string | null;
  metaFieldErrors: ContentPagesMetaFieldErrors | null;
}

export interface ContentPagesAuxState {
  schemas: IContentBlockSchemaItem[];
  schemasReady: boolean;
  blogCategories: IBlogCategoryListItem[];
  coverUploading: boolean;
}

export interface ContentPagesAutosaveState {
  isInitialSyncDone: boolean;
  lastPatchedPayload: string | null;
  isPatching: boolean;
  hasUnsavedChanges: boolean;
  lastSavedAt: string | null;
}

export interface ContentPagesState {
  list: ContentPagesListState;
  editor: ContentPagesEditorState;
  aux: ContentPagesAuxState;
  autosave: ContentPagesAutosaveState;
  error: SerializedError | IApiError | null;
}

export const initialState: ContentPagesState = {
  list: {
    items: [],
    isLoading: false,
    currentPage: 1,
    total: 0,
    pageSize: 10,
    blogCategoryId: null,
    search: '',
    searchId: '',
    searchAuthor: '',
    sortField: 'created_at',
    sortDirection: 'desc',
  },
  editor: {
    page: null,
    isPageLoading: true,
    isSaving: false,
    isReverting: false,
    selectedBlockId: null,
    metaFieldErrors: null,
  },
  aux: {
    schemas: [],
    schemasReady: false,
    blogCategories: [],
    coverUploading: false,
  },
  autosave: {
    isInitialSyncDone: false,
    lastPatchedPayload: null,
    isPatching: false,
    hasUnsavedChanges: false,
    lastSavedAt: null,
  },
  error: null,
};
